import { render } from "./QAppleDownload.vue?vue&type=template&id=221a951f"
const script = {}

import exportComponent from "../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/QAppleDownload.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "221a951f"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('221a951f', __exports__)) {
    api.reload('221a951f', __exports__)
  }
  
  module.hot.accept("./QAppleDownload.vue?vue&type=template&id=221a951f", () => {
    api.rerender('221a951f', render)
  })

}


export default __exports__